import { Fragment, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { SafeDatatable } from "../../components/SafeDatatable";
//import ReactDatatable from "@ashvin27/react-datatable";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faEdit, faTrash, faFileImport, faFileExport, faEraser, faMagnifyingGlass,faArrowRightArrowLeft } from "@fortawesome/free-solid-svg-icons";

import _ from 'lodash';

import { DatasetDefault, DatasetModel } from "../../models/dataset.model";
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../models/requestInputOutputParams.model";
import { TransporterModel } from "../../models/transporter.model";

import { ErrorHandler } from "../../services/errorHandler.service";
import { ToastService } from "../../services/toast.service";
import { BranchService } from "../../services/branch.service";
import TransporterService from "../../services/transporter.service";
import { FileExportService } from "../../services/fileExport.service";

import { HeaderList } from "../../components/HeaderList";
import { CustomModal } from "../../components/Modal";
import ModalImport from "../../components/ModalImport";
 
import {
  ButtonClean,
  ButtonImport,
  ButtonSearch
} from '../../components/buttons';

import {
  DropdownButtonExport
} from '../../components/dropdownButton';
import storageService from "../../services/storage.service";
import UtilService from "../../services/util.service";

/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */
import { ModalIntegrationSiga } from "../../components/ModalIntegrationSiga";
/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */

const BranchList = () => {
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const idiom = storageService.getIdiom();
  const [data, setData] = useState<DatasetModel>();
  const history = useHistory();

  // ---

  const user = storageService.getUser();

  const [showImportModal, setShowImportModal] = useState({
    show: false
  });

  const [showRemoveModal, setShowRemoveModal] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null
  });

  /* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */

  const [showModalIntegrationSiga, setShowRemoveModalIntegrationSiga] = useState({
    id: 0,
    show: false,
    name: "",
    entity: null
  });

  /* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */

  // ---

  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'branch',
    filters: {
      fullname: [],
      nickname: [],
      document: [],
      transporter_id: []
    },
    sort: {
      field: 'fullName',
      orientation: 'asc'
    }
  });

  const [transporters, setTransporters] = useState<TransporterModel[]>();

  const columns = [
    {
      key: "fullName",
      text: t("BRANCH.FULLNAME"),
      align: "left",
      sortable: true
    },
    {
      key: "nickName",
      text: t('BRANCH.NICKNAME'),
      align: "left",
      sortable: true
    },
    {
      key: "document",
      text: t('BRANCH.DOCUMENT'),
      align: "left",
      sortable: true
    },
    {
      key: "transporterName",
      text: t('BRANCH.TRANSPORTERNAME'),
      align: "left",
      sortable: false
    },

    // Sprint 26 - 9951 -  Satellite - Migração das filiais de SP
    {
      key: "integrationSiga",
      text: t("BRANCH.INTEGRATION_SIGA"),
      align: "left",
      sortable: true,
      cell: (record) => {
        return (record.IsIntegrationSiga == 'true' ? t("YES") : t("NO"));
      },
    },
    // Sprint 26 - 9951 -  Satellite - Migração das filiais de SP

    {
      key: "action",
      text: t('ACTIONS'),
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {
        return (
          <Fragment>
            <Dropdown className='btn-toolbar'>
              <Dropdown.Toggle
                as={Button}
                variant='primary'
                size='sm'
                className='me-2'>
                <FontAwesomeIcon icon={faCogs} className='me-2' />
              </Dropdown.Toggle>
              <Dropdown.Menu className='dashboard-dropdown dropdown-menu-left mt-2'>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => history.push(`${pathname}/edit/${record.id}`)}>
                  <FontAwesomeIcon icon={faEdit} className='me-2' /> 
                  {(user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin") ? (
                        t("VIEW")
                      ):
                        t("EDIT")
                  }
                </Dropdown.Item>
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => actionRemove(record.id, record.fullName, record)}
                  disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  >
                  <FontAwesomeIcon icon={faTrash} className='me-2' /> {t('DELETE')}
                </Dropdown.Item>
              {/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */}
                <Dropdown.Item
                  className='fw-bold'
                  onClick={() => actionIntegrationSiga(record.id, record.fullName, record)}
                  disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
                  >
                  <FontAwesomeIcon icon={faArrowRightArrowLeft} className='me-2' /> {t('BRANCH.INTEGRATION_SIGA')}
                </Dropdown.Item>  
              {/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */}
              </Dropdown.Menu>
            </Dropdown>
          </Fragment>
        );
      },
    },
  ];

  // ---

  const actionRemove = (id, name, entity) => { setShowRemoveModal({ id: id, show: true, name: name, entity }); };
  const handleCloseModal = () => setShowRemoveModal({ id: 0, show: false, name: "", entity: null });

  /* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */
  const actionIntegrationSiga = (id, name, entity) => { setShowRemoveModalIntegrationSiga({ id: id, show: true, name: name, entity }); };
  /* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */

  const actionShowImportModal = (entity) => {
    storageService.setImportEntity(entity);
    setShowImportModal({ show: true });
  };
  const handleCloseImportModal = () => {
    storageService.removeImportEntity();
    setShowImportModal({ show: false });
  };

/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */

const handleCloseModalIntegrationSiga = () => setShowRemoveModalIntegrationSiga({ id: 0, show: false, name: "", entity: null });

/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */

  // --- 

  const getList = async (dataTable, datasetOverride = null) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetOverride || dataset] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    let sort = requestParams.datasets[0].sort;
    if (!sort) {
        sort = requestParams.datasets[0].sort = {};
    }
    if (!sort.field || sort.field === null || sort.field.trim?.() === "") {
        sort.field = "fullName";
    }
    if (!sort.orientation || sort.orientation === null || sort.orientation.trim?.() === "") {
        sort.orientation = "asc";
    }

    const response: any = await BranchService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'branch' }));
      setData(d);
    } else {
      requestParams.datasets[0].data = null;
      setData(requestParams.datasets[0]);
    }
    setLoading(false);
  };

  const handleSearch = async (event) => {
    if (event != null)
      event.preventDefault();

    const trimfullname = dataset.filters.fullname?.[0]?.trim() || "";
    const trimnickname = dataset.filters.nickname?.[0]?.trim() || "";
    const trimdocument = dataset.filters.document?.[0]?.trim() || "";

    const cleanedDataset = {
      ...dataset,
      filters: {
        ...dataset.filters,
        fullname: [trimfullname],
        nickname: [trimnickname],
        document: [trimdocument],
      },
    };

    await getList(null, cleanedDataset);
  };

  const tableChangeHandler = async (data) => {
    await getList(data);
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }

  const [flagClear, setFlagClear] = useState(false);

  useEffect(() => {
        if (flagClear)
        {
            handleSearch(null);
            setFlagClear(false);
        }
      }, [flagClear]);

  const handleClean = () => {
  
    setDataset({
      ...dataset, filters: {
        fullname: [],
        nickname: [],
        document: [],
        transporter_id: []
      },
      sort: {
        field: 'fullName',
        orientation: 'asc'
      }
    });
    setFlagClear(true);
  };

  const remove = async () => {
    if (showRemoveModal.id) {
      try {
        const response: any = await BranchService.del(showRemoveModal.entity);
        if (ErrorHandler.success(response)) {
          if (response.success) {
            ToastService.success(t('BRANCH.REMOVED'));
            await getList(null);
            handleClean();
            handleCloseModal(); 
          }          
        }
        else
        {
          handleClean();
          handleCloseModal();
        }
      } catch (error) { }
    }
  };

  /* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */
  const setIntegrationSiga = async (IntegrationSiga) => {


    if (showModalIntegrationSiga.id) {
      
      try {

        if (isLoading == false)
        {
          setLoading(true);

          let requestParams: RequestInputOutputParamsModel = {
            ...RequestInputOutputParamsModelDefault,
            datasets: [dataset],
          };

          const filter: any = await BranchService.getById(showModalIntegrationSiga.id);
          filter.result.IsIntegrationSiga = IntegrationSiga;
          requestParams.datasets[0].data =  [filter.result];
          const response: any = await BranchService.update(requestParams);

          if (ErrorHandler.success(response)) {
            if (response.success) {
              ToastService.success(t('BRANCH.INTEGRATION_UPDATE_SIGA'));
              await getList(null);
              handleClean();
              handleCloseModalIntegrationSiga(); 
            }          
          }
          else
          {
            handleClean();
            handleCloseModalIntegrationSiga();
          }
          setLoading(false);
        }
      } catch (error) { }


    }
  };
  /* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */

  const initialize = async () => {
    await getList(null);

    TransporterService.getAll().then((response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'transporter' }));

        const sort = Array.isArray(d?.data)
          ? d.data.sort((a, b) => (a?.fullName || "").localeCompare(b?.fullName || ""))
          : [];

        setTransporters(sort);
      } 
    });
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`BRANCH.TITLE_LIST`)} disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"} />

      <CustomModal
        Title={t('DELETE')}
        Message={`${t('BRANCH.REMOVE_ANSWER')} ${showRemoveModal ? showRemoveModal.name : ""}?`}
        close={handleCloseModal}
        cancel={t('CANCEL')}
        show={showRemoveModal ? showRemoveModal.show : false}>
        <Button variant='primary' onClick={remove}>
          {t('YES')}
        </Button>
      </CustomModal>

      <ModalImport
        title={t('MODULE_ALERT.IMPORT_OF_OPERATOR_DATA')}
        close={handleCloseImportModal}
        cancel={t('MODULE_ALERT.CLOSE')}
        show={showImportModal ? showImportModal.show : false}
      >
      </ModalImport>
     {/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */}
     <ModalIntegrationSiga
        Title={t("BRANCH.INTEGRATION_SIGA")}
        Message= {t("BRANCH.INTEGRATION_ANSWER_SIGA_PREFIX") + " " + showModalIntegrationSiga.name + " " + t("BRANCH.INTEGRATION_ANSWER_SIGA")}
        close={handleCloseModalIntegrationSiga}
        cancel={t("CANCEL")}
        show={showModalIntegrationSiga ? showModalIntegrationSiga.show : false}
        >
        <Button variant='primary' onClick={() => {setIntegrationSiga(true)}}>
          {t("YES")}
        </Button> 
        <Button onClick={() => {setIntegrationSiga(false)}}>
          {t("NO")}
        </Button> 
      </ModalIntegrationSiga>
      {/* Sprint 26 - 9951 -  Satellite - Migração das filiais de SP */}

      <Form>
        <Form.Label>{t('FILTERS')}</Form.Label>
        <Row>
          <Col xs="2" style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='fullname'
                  id='fullname'
                  type='text'
                  placeholder={t('BRANCH.FULLNAME')}
                  className='form-control'
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, fullname: [e.target.value] } })
                  }}
                  value={dataset?.filters?.fullname.length > 0 ? dataset.filters.fullname[0] : ''}
                />
                <label htmlFor="fullname">{t("BRANCH.FULLNAME")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs="1" style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='nickname'
                  id='nickname'
                  type='text'
                  placeholder={t('BRANCH.NICKNAME')}
                  className='form-control'
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, nickname: [e.target.value] } })
                  }}
                  value={dataset?.filters?.nickname.length > 0 ? dataset.filters.nickname[0] : ''}
                />
                <label htmlFor="nickname">{t("BRANCH.NICKNAME")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs="2" style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  name='document'
                  id='document'
                  type='text'
                  placeholder={t('BRANCH.DOCUMENT')}
                  className='form-control'
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, document: [e.target.value] } })
                  }}
                  value={dataset?.filters?.document.length > 0 ? dataset.filters.document[0] : ''}
                />
                <label htmlFor="document">{t("BRANCH.DOCUMENT")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs="2" style={{padding: '0px 4px'}}>
            <Form.Group>
              <Form.Floating>
                <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.transporter_id.length > 0 ? dataset.filters.transporter_id[0] : ''}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, transporter_id: [Number(e.target.value)] } })
                  }}
                >
                  <option value=''>{t("BRANCH.TRANSPORTERNAME")}</option>
                  {_.map(transporters, (l: TransporterModel) => {
                    return <option key={l.id} value={l.id}>{l.fullName}</option>
                  })}
                </Form.Control>
                <label htmlFor="status">{t("BRANCH.TRANSPORTERNAME")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

          <Col xs="auto" style={{padding: '2px'}}>
          <ButtonSearch onClick={handleSearch} />
          </Col>

          <Col xs="auto" style={{padding: '2px'}}>
          <ButtonClean onClick={async (e) => {e.preventDefault(); handleClean();}} />
          </Col>

          <Col xs="auto" style={{padding: '2px'}}>
            <ButtonImport onClick={() => actionShowImportModal("branch")} disabled={user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}/>
          </Col>

          <Col xs="auto" style={{padding: '2px'}}>
            <DropdownButtonExport onClick={(type: string) =>
              FileExportService.Export(
                { ...RequestInputOutputParamsModelDefault, datasets: [dataset] },
                "Branch",
                type
              )}
            />
          </Col>
        </Row>
      </Form>

      <SafeDatatable
        key={flagClear ? "reset" : JSON.stringify(dataset.filters)}
        config={UtilService.verifyIdiomDataTable()}
        records={data?.data ? data?.data : []}
        columns={columns}
        dynamic={true}
        total_record={data?.pagination?.total_records ? data?.pagination?.total_records : 0}
        onChange={tableChangeHandler}
        className='table table-hover user-table align-items-center'
    />
    
    </>
  );
};

export default BranchList;